import { Component } from 'opus-angular-seed-core';
import template from './template.html';
@Component({
    bindings: {
        classifiers: '=',
        employees: '=',
        sites: '='
    },
    template
})
export default class {
    constructor ($window, $scope, $stateParams, lodash, moment, $timeout, $translate, DATATABLES,
                 COURSE_TRAINING_ORDER_TYPE_ENUM, COURSE_TRAINING_TYPE_ENUM,
                 COURSE_STATUS_TYPE_ENUM, COURSE_TRAINING_STATUS_TYPE_ENUM,
                 COURSE_TARGET_NEED_TYPE_ENUM, ListFactory, CourseResource, AuthResource,
                 TokenService, ModalService, PrivilegeService, ReportService,
                 USER_STATUS_ENUM, ErrorHandlerFactory) {
        this.$window = $window;
        $scope.Math = $window.Math;
        this.$stateParams = $stateParams;
        this.lodash = lodash;
        this.moment = moment;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.DATATABLES = DATATABLES;
        this.COURSE_TRAINING_ORDER_TYPE_ENUM = COURSE_TRAINING_ORDER_TYPE_ENUM;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
        this.COURSE_STATUS_TYPE_ENUM = COURSE_STATUS_TYPE_ENUM;
        this.COURSE_TRAINING_STATUS_TYPE_ENUM = COURSE_TRAINING_STATUS_TYPE_ENUM;
        this.AuthResource = AuthResource;
        this.CourseResource = CourseResource;
        this.TokenService = TokenService;
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
        this.ReportService = ReportService;
        this.list = ListFactory.createWithPagination(CourseResource.resultsReport.bind(CourseResource));
        this.wrapListFetchWithSummary();
        this.chart = null;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.ErrorHandlerFactory = ErrorHandlerFactory;
    }

    $onInit () {
        this.filterOverview = { };

        const savedFilterRaw = this.$window.localStorage.getItem('courseresults:filter');
        const fromLearnerProgress = this.$window.localStorage.getItem('courseresults:fromLearnerProgress') === '1';
        const savedChosenEmployeesRaw = this.$window.localStorage.getItem('courseresults:chosenEmployees');
        const savedChosenManagersRaw = this.$window.localStorage.getItem('courseresults:chosenManagers');

        if (fromLearnerProgress && savedFilterRaw) {
            try {
                this.filter = JSON.parse(savedFilterRaw);
            }
            catch (e) {
                this.filter = this.buildDefaultFilter();
            }
            try {
                this.chosenEmployees = savedChosenEmployeesRaw ? JSON.parse(savedChosenEmployeesRaw) : [];
            }
            catch (e) {
                this.chosenEmployees = [];
            }
            try {
                this.chosenManagers = savedChosenManagersRaw ? JSON.parse(savedChosenManagersRaw) : [];
            }
            catch (e) {
                this.chosenManagers = [];
            }
        }
        else {
            this.filter = this.buildDefaultFilter();
            this.chosenEmployees = [];
            this.chosenManagers = [];
        }

        this.list.pagination.perPage = 25;
        this.list.fetch({}, this.filter);
        this.saveFilterForLearnerProgress();
        this.defaultFilter = angular.copy(this.buildDefaultFilter());
        this.canSeeEmployeeResultsReport = this.PrivilegeService.canViewEmployeeResultsReport();
    }

    buildDefaultFilter () {
        const filter = {};
        filter.from = this.moment().subtract(60, 'days').format('YYYY-MM-DD');
        filter.to = this.moment().format('YYYY-MM-DD');
        filter.siteIds = this.sites.map(site => site.id);
        if (this.TokenService.isOptionalCoursesModuleEnabled()) {
            filter.participationTypes = [
                this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.COMPULSORY,
                this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.OPTIONAL
            ];
        }
        filter.employeeStatuses = [this.USER_STATUS_ENUM.KEYS.ACTIVE];
        filter.includeArchived = false;
        return filter;
    }

    saveFilterForLearnerProgress () {
        this.$window.localStorage.setItem('courseresults:filter', JSON.stringify(this.filter));
        this.$window.localStorage.setItem('courseresults:chosenEmployees', JSON.stringify(this.chosenEmployees || []));
        this.$window.localStorage.setItem('courseresults:chosenManagers', JSON.stringify(this.chosenManagers || []));
        this.$window.localStorage.setItem('courseresults:fromLearnerProgress', '1');
    }

    /**
     * Wraps list.fetch to also fetch summary totals when filter parameters change
     */
    wrapListFetchWithSummary () {
        const originalFetch = this.list.fetch.bind(this.list);
        this.list.fetch = (query, postParameters) => {
            if (postParameters) {
                this.fetchSummary(postParameters);
            }
            const result = originalFetch(query, postParameters);
            if (result && typeof result.then === 'function') {
                result.then(() => {
                    this.reinitializeChartAfterLoad();
                });
            }
            return result;
        };
    }

    /**
     * Re-initializes the chart after list loading completes,
     * since ng-if removes and recreates the canvas element
     */
    reinitializeChartAfterLoad () {
        if (this.summary && this.summary.totalEnrollments > 0) {
            this.$timeout(() => {
                this.initializeChart();
            }, 100);
        }
    }

    /**
     * Fetches summary totals from the dedicated summary endpoint
     * @param {Object} filter
     */
    fetchSummary (filter) {
        this.CourseResource.resultsReportSummary({}, filter).$promise
            .then((response) => {
                this.summary = response;
                if (this.summary && this.summary.totalEnrollments > 0) {
                    this.$timeout(() => {
                        this.initializeChart();
                    }, 100);
                }
            });
    }

    initializeChart () {
        const ctx = document.getElementById('resultsPieChart');
        if (ctx && this.summary) {
            if (this.chart) {
                this.chart.destroy();
            }
            const labels = [
                this.$translate.instant('reports.Completed'),
                this.$translate.instant('reports.Not completed'),
                this.$translate.instant('reports.In progress'),
                this.$translate.instant('reports.Not started')
            ];
            const data = [
                this.summary.completed,
                this.summary.notCompleted,
                this.summary.inProgress,
                this.summary.notStarted
            ];
            this.chart = new Chart(ctx, { // eslint-disable-line
                type: 'doughnut',
                data: {
                    labels,
                    datasets: [{
                        label: '',
                        data,
                        borderWidth: 1,
                        backgroundColor: ['#261c69', '#5344d1', '#ff5a5b', '#ffa19e'],
                        borderColor: '#ffffff',
                        hoverOffset: 8
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutout: '85%',
                    plugins: {
                        legend: {
                            position: 'bottom'
                        },
                        tooltip: {
                            callbacks: {
                                label: function (tooltipItem) { // eslint-disable-line
                                    const value = tooltipItem.raw || 0;
                                    return ` ${value}`;
                                }
                            }
                        }
                    }
                }
            });
        }
    }

    exportCsv () {
        const filter = {
            'siteIds[]': this.filter.siteIds,
            'participationTypes[]': this.filter.participationTypes,
            'employeeStatuses[]': this.filter.employeeStatuses,
            'uDepIds[]': this.filter.uDepIds,
            'uRoleIds[]': this.filter.uRoleIds,
            'uLevelIds[]': this.filter.uLevelIds,
            'trainingFieldIds[]': this.filter.trainingFieldIds,
            'directManagerIds[]': this.filter.directManagerIds,
            'employeeIds[]': this.filter.employeeIds,
            course: this.filter.course,
            to: this.filter.to,
            from: this.filter.from,
            includeArchived: this.filter.includeArchived
        };
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const qs = this.ReportService.buildQueryString(filter);
                const lang = this.TokenService.getActiveLanguage(true);
                const url = `${SEED_CORE.ENV.API_URL}course/course/results-report-export?tacToken=${token}&${qs}&_lang=${lang}`;
                this.$window.open(url);
            });
    }

    showCourseUserResults (course, courseId, statuses, condition, forceShowCsvExport = false) {
        const { sites, classifiers, filter, lodash } = this;
        return this.ModalService.open({
            template: `
                <modals-report-courseresults-user
                    class="wrapper"
                    cancel="vm.$uibModalInstance.dismiss()"
                    sites="vm.sites"
                    classifiers="vm.classifiers"
                    default-filter="vm.defaultFilter"
                    force-show-csv-export="vm.forceShowCsvExport"
                />
            `,
            size: 'xlarge',
            controller ($uibModalInstance, TokenService, COURSE_TARGET_NEED_TYPE_ENUM) {
                this.$uibModalInstance = $uibModalInstance;
                this.TokenService = TokenService;
                this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
                this.sites = sites;
                this.classifiers = classifiers;
                this.defaultFilter = {
                    employeeStatuses: filter.employeeStatuses,
                    course,
                    courseId,
                    statuses,
                    condition,
                    siteIds: filter.siteIds,
                    to: filter.to,
                    from: lodash.has(filter, 'from') ? filter.from : null
                };
                this.forceShowCsvExport = forceShowCsvExport;

                if (this.TokenService.isOptionalCoursesModuleEnabled()) {
                    this.defaultFilter.participationTypes = filter.participationTypes;
                }

                if (filter.uDepIds) {
                    lodash.assign(this.defaultFilter, { departmentIds: filter.uDepIds });
                }

                if (filter.uRoleIds) {
                    lodash.assign(this.defaultFilter, { roleIds: filter.uRoleIds });
                }

                if (filter.uLevelIds) {
                    lodash.assign(this.defaultFilter, { levelIds: filter.uLevelIds });
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/courseresults/index.js